
export default {
  name: 'MegasredaContentRecommendationsCreate',
  props: {
    author: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      streamsVisibleCount: 8,
      filterMenu: [],
      isShowAllMenu: false,
      recommendation: {
        text: null,
      },
    }
  },
  methods: {
    async open() {
      await this.createRecommendation()
      this.$refs.recommendedPopUp.open()
    },
    async createRecommendation() {
      if (!this.$auth.loggedIn) {
        this.$router.push('/login')
      } else {
        try {
          const recommendation = await this.$axios.$post(
            '/recommendations/create',
            {
              target: this.author.id,
            }
          )

          this.recommendation = recommendation
        } catch (error) {
          console.log(error)
        }
      }
    },
    async contentChange(content) {
      this.recommendation.text = content
      try {
        await this.$axios.$put('/recommendations/update', this.recommendation)
      } catch (error) {
        console.log(error)
      }
    },

    async publishRecommendation() {
      try {
        await this.$axios.$put(
          `/recommendations/publish/${this.recommendation._id}`
        )
        this.$refs.recommendedPopUp.close()
        this.$eventBus.$emit('publish-recommendation')
        this.$emit('update')
      } catch (error) {
        console.log(error)
      }
    },
    closeRecommendationPopUp() {
      this.$refs.recommendedPopUp.close()
    },
  },
}
